import { initComponents } from "./../utils/initComponents";
import { onLoadEvents } from "./../utils/onLoadEvents";
import Header from "./../components/Header";
import Accordion from "./../components/Accordion";
// import Modal from "./../components/Modal";
import CookieBanner from "./../components/CookieBanner";
import Article from "./../components/Article";
import AlertBanner from "./../components/AlertBanner";
import AnchorLinks from "../components/AnchorLinks";
import Form from "./../components/Form";
import FooterTicker from "../components/FooterTicker";
import SubmenuCarousel from "../components/SubmenuCarousel";
import LandingTicker from "../components/LandingTicker";
import StatAccordion from "../components/StatAccordion";
import SeeMore from "../components/SeeMore";
//import KeyIndicesScrollingTicker from "../components/KeyIndicesScrollingTicker";

// Vue
import ContentListingBlock from "./../components/ContentListingBlock.vue";
import { createApp } from "vue";
import VueAwesomePaginate from "vue-awesome-paginate";
import "vue-awesome-paginate/dist/style.css";

/**
 * Global variables
 */
window.breakpoint = 992;

/**
 * Init App
 */
const APP = {};
APP.helpers = {
  initComponents: (elem) => initComponents(elem, APP),
  onLoadEvents: (elem) => onLoadEvents(elem, APP),
  // initLazyLoading: (APP) => initLazyLoading(APP),
};

/**
 * Page components
 * <elem data-component="<component name>">
 */
APP.components = {
  Header: (elem) => new Header(elem, APP).init(),
  Accordion: (elem) => new Accordion(elem, APP).init(),
  CookieBanner: (elem) => new CookieBanner(elem, APP).init(),
  Article: (elem) => new Article(elem, APP).init(),
  AlertBanner: (elem) => new AlertBanner(elem, APP).init(),
  AnchorLinks: (elem) => new AnchorLinks(elem, APP).init(),
  Form: (elem) => new Form(elem, APP).init(),
  FooterTicker: (elem) => new FooterTicker(elem, APP).init(),
  SubmenuCarousel: (elem) => new SubmenuCarousel(elem, APP).init(),
  LandingTicker: (elem) => new LandingTicker(elem, APP).init(),
  StatAccordion: (elem) => new StatAccordion(elem, APP).init(),
  SeeMore: (elem) => new SeeMore(elem, APP).init(),
  //KeyIndicesScrollingTicker: (elem) => new KeyIndicesScrollingTicker(elem, APP).init(),
};

/**
 * Init Vue based on the templates
 * This is for the custom post type archive page
 * See component-content_listing_block.twig
 */
if (document.querySelector("#vue-content-listing-block")) {
  const container = createApp({});
  container.use(VueAwesomePaginate);
  container.component("content-listing", ContentListingBlock);
  container.mount("#vue-content-listing-block");
}


export default APP;
